<template>
  <div>
    <h3 class="text-primary"><i class="fa fa-envelope me-2"></i> {{ $t("messages.title") }}</h3>
    <p class="text-muted">{{ $t("messages.info") }}</p>

    <!-- Listă Mesaje -->
    <div class="table-responsive" v-if="messages.length">
      <table class="table table-striped table-hover rounded">
        <thead class="bg-primary text-white">
          <tr class="text-center">
            <th><i class="fa fa-tag me-1"></i> {{ $t("messages.subject") }}</th>
            <th><i class="fa fa-tags me-1"></i> {{ $t("messages.type") }}</th>
            <th><i class="fa fa-calendar me-1"></i> {{ $t("messages.date") }}</th>
            <th><i class="fa fa-eye me-1"></i> {{ $t("messages.status") }}</th>
            <th><i class="fa fa-cogs me-1"></i> {{ $t("messages.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="message in messages" :key="message.id" class="text-center">
            <td>{{ message.message__subject }}</td>
            <td>{{ getMessageType(message.message__message_type) }}</td>
            <td>{{ formatDate(message.message__created_at) }}</td>
            <td>
              <span :class="{'badge bg-success': message.is_read, 'badge bg-warning text-dark': !message.is_read}">
                {{ message.is_read ? $t("messages.read") : $t("messages.unread") }}
              </span>
            </td>
            <td>
              <button class="btn btn-outline-primary btn-sm" @click="viewMessage(message)">
                <i class="fa fa-eye me-1"></i> {{ $t("messages.viewMessage") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mesaj dacă nu există mesaje -->
    <div v-else class="alert alert-warning text-center">
      <i class="fa fa-info-circle me-2"></i> {{ $t("messages.noMessages") }}
    </div>

    <!-- MODAL Vizualizare Mesaj fără Bootstrap JS -->
    <div v-if="showModal" class="custom-modal">
      <div class="custom-modal-content">
        <div class="custom-modal-header">
          <h5 class="modal-title"><i class="fa fa-envelope-open-text me-2"></i> {{ selectedMessage?.message__subject }}</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="custom-modal-body">
          <p><strong>{{ $t("messages.type") }}:</strong> {{ getMessageType(selectedMessage?.message__message_type) }}</p>
          <p><strong>{{ $t("messages.date") }}:</strong> {{ formatDate(selectedMessage?.message__created_at) }}</p>
          <hr />
          <p v-html="selectedMessage?.message_content"></p>
        </div>
        <div class="custom-modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            <i class="fa fa-times"></i> {{ $t("messages.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ClientMessages",
  data() {
    return {
      messages: [],
      selectedMessage: null,
      showModal: false,
    };
  },
  async mounted() {
    await this.fetchMessages();
  },
  methods: {
    async fetchMessages() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/client/api/messages/", {
          withCredentials: true,
        });
        this.messages = response.data.messages;
      } catch (error) {
        console.error("Eroare la preluarea mesajelor:", error);
      }
    },
    async viewMessage(message) {
      this.selectedMessage = { ...message, message_content: "Se încarcă conținutul..." };

      if (!message.is_read) {
        await this.markAsRead(message.id);
      }

      try {
        const response = await axios.get(`https://api.feribot-eurobac.ro/client/api/messages/${message.id}/`, {
          withCredentials: true,
        });
        this.selectedMessage.message_content = response.data.message_content;
      } catch (error) {
        console.error("Eroare la preluarea conținutului mesajului:", error);
      }

      this.$nextTick(() => {
        this.showModal = true;
      });
    },
    closeModal() {
      this.showModal = false;
      this.selectedMessage = null;
    },
    async markAsRead(messageId) {
      try {
        await axios.post("https://api.feribot-eurobac.ro/client/api/messages/read/", { message_id: messageId }, {
          withCredentials: true,
        });

        const message = this.messages.find(msg => msg.id === messageId);
        if (message) message.is_read = true;
      } catch (error) {
        console.error("Eroare la marcarea mesajului ca citit:", error);
      }
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    getMessageType(type) {
      const types = {
        newsletter: this.$t("messages.typeNewsletter"),
        offer: this.$t("messages.typeOffer"),
        announcement: this.$t("messages.typeAnnouncement"),
      };
      return types[type] || type;
    },
  },
};
</script>

<style scoped>
/* 🟢 Stilizare pentru modal */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.custom-modal-content {
  background: #fff;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  border-radius: 10px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.custom-modal-body {
  padding: 15px 0;
}

.custom-modal-footer {
  text-align: right;
  padding-top: 10px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* Stilizare tabel */
.table {
  border-radius: 8px;
  overflow: hidden;
}

/* Badge Styling */
.badge {
  font-size: 0.9rem;
  padding: 0.5em;
}

/* Culori */

.btn-outline-primary {
  font-size: 0.9rem;
}
</style>

  